export const statusCommissionReportAutocomplete = [
  { id: 'NEW', name: 'New', active: true },
  { id: 'FUNDED', name: 'Funded', active: true },
  { id: 'BLOCKED', name: 'Blocked', active: true },
  { id: 'DELETED', name: 'Deleted', active: true },
  { id: 'ACTIVE', name: 'Active', active: true },
  { id: 'REPAID', name: 'Repaid', active: true },
];
